import React, { useState } from "react";

const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

const typeLabel = {
    QUESTION_ANSWERED: "Réponse",
    USER_MENTIONED: "Mention",
    BEST_ANSWER_SELECTED: "Meilleure réponse",
    QUESTION_RESOLVED: "Résolution",
};

export default function ContentQuestionNotifications({
    notifications = [],
    onOpen,
    onMarkRead,
    onMarkAllRead,
    loading,
}) {
    const [open, setOpen] = useState(false);
    const unreadCount = notifications.filter((notification) => notification.unread).length;

    return (
        <div className="cq-notifications">
            <button type="button" className="cq-notifications-toggle" onClick={() => setOpen((value) => !value)}>
                Notifications
                {unreadCount > 0 ? <span>{unreadCount}</span> : null}
            </button>

            {open ? (
                <div className="cq-notifications-panel">
                    <div className="cq-notifications-head">
                        <strong>Notifications Q/R</strong>
                        <button type="button" onClick={onMarkAllRead} disabled={loading || unreadCount === 0}>
                            Tout marquer lu
                        </button>
                    </div>
                    {notifications.length === 0 ? (
                        <div className="cq-notification-empty">Aucune notification.</div>
                    ) : (
                        notifications.slice(0, 12).map((notification) => (
                            <div key={notification.id} className={`cq-notification ${notification.unread ? "is-unread" : ""}`}>
                                <button type="button" className="cq-notification-main" onClick={() => onOpen?.(notification)}>
                                    <span>{typeLabel[notification.type] || "Notification"}</span>
                                    <strong>{notification.message}</strong>
                                    <small>{formatDate(notification.createdAt)}</small>
                                </button>
                                {notification.unread ? (
                                    <button type="button" className="cq-notification-read" onClick={() => onMarkRead?.(notification.id)} disabled={loading}>
                                        Lu
                                    </button>
                                ) : null}
                            </div>
                        ))
                    )}
                </div>
            ) : null}
        </div>
    );
}
